import React, { useState } from 'react';
import { db } from '../../config/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import './tracking.css';

const TrackApplication = () => {
    const [applicationCode, setApplicationCode] = useState('');
    const [application, setApplication] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleTrack = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setApplication(null);

        try {
            const q = query(collection(db, 'volunteerApplications'), where('code', '==', applicationCode));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                setError('Application not found. Please check your application code.');
            } else {
                const appData = querySnapshot.docs[0].data();
                setApplication(appData);
            }
        } catch (error) {
            console.error('Error tracking application:', error);
            setError('There was an error tracking your application. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='track_container'>
            <h1>Track Your Application</h1>
            <form onSubmit={handleTrack}>
                <label htmlFor="applicationCode" className='label_tag'>Application Code:</label>
                <input 
                    type="text" 
                    placeholder='Enter your application code' 
                    required 
                    className='input_tag' 
                    value={applicationCode} 
                    onChange={(e) => setApplicationCode(e.target.value)} 
                />
                <button className='form_btn' type="submit" disabled={isLoading}>Track</button>
            </form>
            {isLoading && <p>Loading...</p>}
            {error && <p className='error_message'>{error}</p>}
            {application && (
                <div className='application_details'>
                    <h2>Application Details</h2>
                    <p><strong>Status:</strong> {application.status}</p>
                    <p><strong>Position:</strong> {application.position}</p>
                    <p><strong>Name:</strong> {application.volunteerName}</p>
                    <p><strong>Email:</strong> {application.email}</p>
                    <p><strong>Cell No:</strong> {application.cellNo}</p>
                    <a href={application.cvUrl} target="_blank" rel="noopener noreferrer">Download CV</a>
                    <p><strong>Submitted at:</strong> {application.submittedAt.toDate().toLocaleString()}</p>
                </div>
            )}
        </div>
    );
}

export default TrackApplication;
